import React from "react";
import { Modal, Box, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Pencil, ToggleRight, ArrowLeft } from "lucide-react";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(360px, 92vw)",
  bgcolor: "#fff",
  borderRadius: "18px",
  boxShadow: "0 16px 40px rgba(0, 0, 0, 0.16)",
  p: 2,
};

export default function ModalOpcoesAtendimento({
  open,
  onClose,
  onEditar,
  onAlternarStatus,
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <List disablePadding>
          <ListItemButton sx={{ borderRadius: 2, mb: 0.5 }} onClick={onEditar}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <Pencil size={18} />
            </ListItemIcon>
            <ListItemText
              primary="Editar"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>
          <ListItemButton sx={{ borderRadius: 2, mb: 0.5 }} onClick={onAlternarStatus}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <ToggleRight size={18} />
            </ListItemIcon>
            <ListItemText
              primary="Ativar/Inativar"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>
          <ListItemButton sx={{ borderRadius: 2, mt: 1 }} onClick={onClose}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <ArrowLeft size={18} />
            </ListItemIcon>
            <ListItemText
              primary="Voltar"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>
        </List>
      </Box>
    </Modal>
  );
}
